import _ from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { Dropdown, Grid, List } from 'semantic-ui-react';
import { ParentContext } from '../../../cnr/contexts/ParentContext';
import { FormItemContext } from '../FormItem';

const AppUserDataPermissions = () => {

  // formItemContext
  const formItemContext = useContext(FormItemContext)
  const { formItem_state } = formItemContext ?? {}
  const { fip } = formItem_state ?? {}
  const { onChange, value: value_prop } = fip ?? {}

  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { eventInfo_state, currentSettings_state } = states ?? {}
  const { aps_appUserSettings, viewItemsList } = _.get(currentSettings_state, 'gvviSettings', {});
  const { staticViews } = eventInfo_state ?? {}
  const { appUserViewTypeProp, appUserDataModifications } = aps_appUserSettings ?? {}

  const [appUserTypes, setAppUserTypes] = useState([]);
  const [collectionOptions, setCollectionOptions] = useState([]);

  const handleChange = (a, b) => {
    const { appusertype, value } = b
    const { key, name } = appusertype
    const _appUserDataModifications = appUserDataModifications ? appUserDataModifications : {}
    _appUserDataModifications[key] = value
    const x = {
      propname: fip.propname,
      value: _appUserDataModifications,
    }
    onChange(null, x)
  }

  useEffect(() => {
    let _appUserTypes = {};
    if (appUserViewTypeProp && staticViews && staticViews[appUserViewTypeProp]) {
      const svau = staticViews[appUserViewTypeProp]
      _.forEach(svau, (item, key) => {
        _appUserTypes[key] = {
          key,
          name: _.camelCase(item.name)
        }
        // _appUserTypes.push(_.camelCase(item.name))
      })
    }
    const sortedAppUserTypes = _.sortBy(_appUserTypes, 'name')
    console.log('sortedAppUserTypes', sortedAppUserTypes)
    setAppUserTypes(sortedAppUserTypes)

    const sortedViewItemsList = _.sortBy(_.filter(viewItemsList, type => type !== '_itemKey'));
    sortedViewItemsList.unshift('all')
    const _collectionOptions = sortedViewItemsList.map(type => ({
      key: type,
      text: _.startCase(type),
      value: type,
    }));
    setCollectionOptions(_collectionOptions)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  const list = () => <List divided relaxed>
    {appUserTypes.map((appUserAccessType, index) => {
      const { key, name } = appUserAccessType
      const _value = value_prop && value_prop[key] ? value_prop[key] : null
      return <List.Item key={index}>
        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              <List.Content>{_.startCase(name)}</List.Content>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <Dropdown
                placeholder='Select Collection(s)'
                fluid
                selection
                options={collectionOptions}
                direction='left'
                multiple
                appusertype={appUserAccessType}
                value={_value}
                onChange={handleChange}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </List.Item>
    })}
  </List>

  return list()

}

export default AppUserDataPermissions